// Pezzi comuni delle pagine Strip LED e Alimentatori (redesign 2026-10, stile del Catalogo).
import React from 'react';
import { FiMinus, FiPlus, FiShoppingCart, FiCheck, FiSliders } from 'react-icons/fi';

export const formatEuro = (value) =>
  `€ ${Number(value || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Icona PDF classica: foglio rosso con la scritta PDF
export const PdfButton = ({ onClick, label }) => (
  <button type="button" className="sp-pdf" onClick={onClick} title={label}>
    <svg className="sp-pdfico" viewBox="0 0 24 30" aria-hidden="true">
      <path d="M3 1h12l7 7v19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z" fill="#E2231A" />
      <path d="M15 1v5a2 2 0 0 0 2 2h5z" fill="#FFB3AE" />
      <text x="11.5" y="22.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="7.6" fontWeight="700" fill="#fff">PDF</text>
    </svg>
    {label}
  </button>
);

// Quantità − / + con campo numerico
export const QtyStepper = ({ value, onChange, label }) => (
  <span className="sp-qty">
    <button type="button" aria-label="−" onClick={() => onChange(Math.max(1, (parseInt(value, 10) || 1) - 1))}><FiMinus aria-hidden="true" /></button>
    <input
      type="number"
      min="1"
      value={value}
      aria-label={label}
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => onChange(Math.max(1, parseInt(value, 10) || 1))}
    />
    <button type="button" aria-label="+" onClick={() => onChange((parseInt(value, 10) || 0) + 1)}><FiPlus aria-hidden="true" /></button>
  </span>
);

export const AddButton = ({ onClick, label }) => (
  <button type="button" className="sp-add" onClick={onClick}>
    <FiShoppingCart aria-hidden="true" /> {label}
  </button>
);

// Messaggio "aggiunto al carrello" sotto l'intestazione, con il link al carrello
export const AddedToast = ({ message, onGoToCart, goToCartLabel }) => (
  <div className={`cat-toast${message ? ' is-on' : ''}`} role="status" aria-live="polite">
    {message && (
      <>
        <i aria-hidden="true"><FiCheck /></i>
        <span>{message}</span>
        <button type="button" onClick={onGoToCart}>{goToCartLabel}</button>
      </>
    )}
  </div>
);

// Gruppo di filtri a pillole (uno per gruppo; ricliccando si toglie)
export const ChipGroup = ({ title, options, active, onToggle }) => (
  <div className="cat-fgrp">
    <b>{title}</b>
    <div className="cat-chips">
      {options.map((o) => (
        <button key={o.value} type="button" className="cat-chip" aria-pressed={active === o.value} onClick={() => onToggle(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  </div>
);

// Pulsante "Filtri" e pannello dal basso, su telefono
export const MobileFiltersButton = ({ label, count, onOpen, onReset, resetLabel, hasFilters }) => (
  <div className="cat-mfilters">
    <button type="button" className="cat-mbtn" onClick={onOpen}>
      <FiSliders aria-hidden="true" /> {label}
      {count > 0 && <span className="cat-n">{count}</span>}
    </button>
    {hasFilters && <button type="button" className="cat-reset" onClick={onReset}>{resetLabel}</button>}
  </div>
);

export const FiltersSheet = ({ open, onClose, title, resetLabel, onReset, hasFilters, showLabel, children }) => {
  if (!open) return null;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="cat-fsheet" onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className="cat-fpanel" onClick={(e) => e.stopPropagation()}>
        <h3>
          {title}
          <button type="button" className="cat-reset" onClick={onReset} disabled={!hasFilters}>{resetLabel}</button>
        </h3>
        {children}
        <button type="button" className="cat-cta" onClick={onClose}>{showLabel}</button>
      </div>
    </div>
  );
};

// Foto del prodotto; se manca o non si carica, riquadro neutro
export const ProductPhoto = ({ src, alt }) => {
  const [broken, setBroken] = React.useState(false);
  if (!src || broken) return <span className="sp-nopic" aria-hidden="true" />;
  return <img src={src} alt={alt} loading="lazy" onError={() => setBroken(true)} />;
};

// Griglia di dati tecnici (etichetta piccola + valore)
export const SpecGrid = ({ cells, cols = 4 }) => (
  <div className={`sp-specs is-${cols}`}>
    {cells.map(({ label, value, highlight }) => (
      <div key={label} className={highlight ? 'is-hi' : ''}>
        <span>{label}</span>
        <b title={value || '—'}>{value || '—'}</b>
      </div>
    ))}
  </div>
);
